import React, { useEffect, useState } from "react";
import AdminLayout from "../../components/AdminLayout";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const NewsLetter = () => {
  const [newsLetter, setNewsLetter] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchNewsLetter = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;

        // const response = await axios.get("/api/user/allUsers");
        const response = await axios({
          method: "GET",
          baseURL: `${apiUrl}/api/`,
          url: "newsletter",
        });

        const NewsLetterData = response.data.newsLetterForm;

        const sortedNewsLetter = [...NewsLetterData].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        console.log(response.data.newsLetterForm);
        setNewsLetter(sortedNewsLetter);
      } catch (error) {
        console.error("Error fetching factsheet form:", error);
      }
    };

    fetchNewsLetter();
  }, []);

  const handleDelete = async (id) => {
    try {
      const access_token = localStorage.getItem("access_token");
      const apiUrl = process.env.REACT_APP_API_URL;

      const response = await axios({
        method: "DELETE",
        baseURL: `${apiUrl}/api/`,
        url: `factsheet-form/${id}`,
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setNewsLetter(null); // Update user state to null after deletion
      // setTimeout(() => {
      //   navigate("/admin/FactsheetPresentation");
      // }, 2000);
      console.log(response.data);
      setNewsLetter(newsLetter.filter((newsLetter) => newsLetter._id !== id));
      setTimeout(() => {
        navigate("/admin/factsheet-form");
      }, 3000);
    } catch (error) {
      console.error("Error deleting factsheet form:", error);
    }
  };

  const filteredNewsLetter = newsLetter.filter((c) =>
    c.first_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const downloadExcel = () => {
    // Create a worksheet from the contact data
    const worksheet = XLSX.utils.json_to_sheet(
      newsLetter.map(({ first_name, last_name, email, createdAt }) => ({
        First_Name: first_name,
        Last_Name: last_name,
        Email: email,
        Date: new Date(createdAt).toLocaleDateString("en-IN"),
        Time: new Date(createdAt).toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
        }),
      }))
    );

    // Create a workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Newsletter Forms");

    // Generate a buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save to file
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "NewsLetterList.xlsx");
  };

  return (
    <AdminLayout>
      <div className="pages-headers ">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6">
            <h2>NewsLetters</h2>
          </div>
          <div className="col-lg-4">
            <form className="d-flex" onSubmit={(e) => e.preventDefault()}>
              <input
                className="form-control"
                type="search"
                placeholder="Search by name"
                aria-label="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </form>
          </div>
          <div className="col-lg-2 mt-lg-0 mt-4">
            <button onClick={downloadExcel} className="theme-cta border-0">
              Download Excel
            </button>
          </div>
        </div>
      </div>
      <div className="row mobilerows">
        <div className="col-md-12">
          <div className="infos-table">
            <div className="table-responsive">
              <table id="example" className="table nowrap">
                <thead>
                  <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th className="text-center">Email</th>
                    <th className="text-center">Date & Time</th>

                    {/* <th className="text-center">Delete</th> */}
                  </tr>
                </thead>
                <tbody>
                  {filteredNewsLetter.length > 0 ? (
                    filteredNewsLetter.map((NewsLetter) => (
                      <tr key={NewsLetter._id}>
                        <td>{NewsLetter.first_name}</td>
                        <td className="text-center">{NewsLetter.last_name}</td>
                        <td className="text-center">{NewsLetter.email}</td>
                        <td className="text-center">
                          {new Date(NewsLetter.createdAt).toLocaleDateString(
                            "en-IN",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              timeZone: "Asia/Kolkata", // Specify the time zone as IST
                            }
                          )}{" "}
                          at{" "}
                          {new Date(NewsLetter.createdAt).toLocaleTimeString(
                            "en-IN",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              timeZone: "Asia/Kolkata", // Specify the time zone as IST
                            }
                          )}
                        </td>
                        {/* <td className="text-center">
                          <button
                            className="delete-btn"
                            onClick={() => handleDelete(NewsLetter._id)}
                          >
                            <i class="las la-trash"></i>{" "}
                          </button>
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No newsletter data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default NewsLetter;
